import FxxlCore from '@fxxl/core';

const  modalOpenedEvent = FxxlCore.getConfig().eventNames.jsonModalOpened;

/**
 * Erlaubt es, auf das Öffnen eines Json-Modals zu reagieren.
 *
 * Verschiedene Modale werden durch einen `kind`-Parameter unterschieden.
 */
export default class JsonModalController {
    static readonly kinds = new Map([
        ['ADD_TO_CART', Symbol('ADD_TO_CART_MODAL_OPENED')]
    ]);

    /**
     * Teilt dieser Klasse mit, dass ein Modal geöffnet wurde.
     *
     * @param kindName Die "Art" des Modals.
     * @param containerElement Das DOM-Element, dass den Inhalt des Modals enthält.
     */
    static notifyModalOpened(kindName: string, containerElement: HTMLElement): void
    {
        const modalInfo = {
            kind: JsonModalController.kinds.get(kindName),
            container_element: containerElement,
        };
        FxxlCore.eventEmitter(modalOpenedEvent).emit(modalInfo, document);
    }

    /**
     * Registriert einen Handler, der beim Öffnen eine Modal (eines bestimmten Typs) ausgeführt wird.
     */
    static onModalOpened(kindName: string, handler: (containerElement: HTMLElement) => void)
    {
        document.addEventListener(modalOpenedEvent, (event: Event): void => {
            if (
                event instanceof CustomEvent
                && event.detail.kind === JsonModalController.kinds.get(kindName)
                && event.detail.container_element instanceof HTMLElement
            ) {
                handler(event.detail.container_element);
            }
        });
    }
}